export enum POSTemplates {
  A4 = 0,
  Six_By_Three = 1,
}
